<template>
  <section>
    <top-menu/>

    <!-- Loading from page -->
    <full-loading v-if="loadingBenefits"/>

    <section v-else>
      <div class="page-content">
        <div class="container-fluid">
          <div class="row first__row">
            <!-- header -->
            <div class="col-md-12 header">
              <div class="header__content">
                <div class="header__content--balance">
                  Saldo na PMA: <span>{{ contentDashboard.summaryPMA.total }}</span>
                </div>
                <div class="header__content--cards">
                  <div class="header__content--cards--total">
                    Total cartões: <span>{{ contentDashboard.summaryCard.total }}</span>
                  </div>
                  <div class="header__content--cards--status">
                    <div class="header__content--cards--status--active">
                      <div class="circle-green"></div>
                      Ativos: <span>{{ contentDashboard.summaryCard.active }}</span>
                    </div>
                    <div class="header__content--cards--status--canceled">
                      <div class="circle-red"></div>
                      Cancelados: <span>{{ contentDashboard.summaryCard.canceled }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- dashboard -->
            <div class="col-md-4 dashboard__card">
              <div class="dashboard__card__content">
                <div class="dashboard__card__header">
                <span class="dashboard__card__header--title">
                  Pedidos
                  <a id="request60" class="dashboard__card__header--60" v-on:click="getRequests(60)">60 dias</a>
                  <a id="request30" class="dashboard__card__header--30 activeRequest" v-on:click="getRequests(30)">30 dias</a>
                </span>
                </div>
                <div class="dashboard__card__body">
                  <div class="dashboard__card__body--first">
                    <span class="dashboard__card__body--first-tag">
                      Aguardando
                    </span> <span class="dashboard__card__body--first-value">
                      {{ orderDays.pending }}
                    </span> <a class="dashboard__card__body--first-link" v-on:click="requestFilter(2)"> filtrar </a>
                  </div>
                  <div class="dashboard__card__body--second">
                    <span class="dashboard__card__body--first-tag"> Pago </span>
                    <span class="dashboard__card__body--first-value">
                      {{ orderDays.paid }}
                    </span> <a class="dashboard__card__body--first-link" v-on:click="requestFilter(3)"> filtrar </a>
                  </div>
                  <div class="dashboard__card__body--third">
                    <span class="dashboard__card__body--first-tag">
                      Cancelado
                    </span> <span class="dashboard__card__body--first-value">
                      {{ orderDays.canceled }}
                    </span> <a class="dashboard__card__body--first-link" v-on:click="requestFilter(4)"> filtrar </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 dashboard__card">
              <div class="dashboard__card__content">
                <div class="dashboard__card__header">
                <span class="dashboard__card__header--title">
                  KYC
                  <a id="kyc60" class="dashboard__card__header--60" v-on:click="getKyc(60)">60 dias</a>
                  <a id="kyc30" class="dashboard__card__header--30 activeKyc" v-on:click="getKyc(30)">30 dias</a>
                </span>
                </div>
                <div class="dashboard__card__body">
                  <div class="dashboard__card__body--first">
                    <span class="dashboard__card__body--first-kyc">
                      <span class="point-yellow">
                        Análise
                      </span>
                    </span>
                    <span class="dashboard__card__body--first-value">
                      {{ kycDays.analysys }}
                    </span> <a class="dashboard__card__body--first-link" v-on:click="kycFilter(2)"> filtrar </a>
                  </div>
                  <div class="dashboard__card__body--second">
                    <span class="dashboard__card__body--first-kyc">
                      <span class="point-green">
                        Aprovado
                      </span>
                    </span>
                    <span class="dashboard__card__body--first-value">
                      {{ kycDays.approved }}
                    </span> <a class="dashboard__card__body--first-link" v-on:click="kycFilter(1)"> filtrar </a>
                  </div>
                  <div class="dashboard__card__body--third">
                    <span class="dashboard__card__body--first-kyc">
                      <span class="point-red">
                        Reprovado
                      </span>
                    </span>
                    <span class="dashboard__card__body--first-value">
                      {{ kycDays.reproved }}
                    </span> <a class="dashboard__card__body--first-link" v-on:click="kycFilter(4)"> filtrar </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 dashboard__card">
              <div class="dashboard__card__content">
                <div class="dashboard__card__header">
                <span class="dashboard__card__header--title">
                  Solic. de Cartões
                  <a id="card60" class="dashboard__card__header--60" v-on:click="getCard(60)">60 dias</a>
                  <a id="card30" class="dashboard__card__header--30 activeCard" v-on:click="getCard(30)">30 dias</a>
                </span>
                </div>
                <div class="dashboard__card__body">
                  <div class="dashboard__card__body--first">
                    <span class="dashboard__card__body--first-card">
                      Pendente
                    </span> <span class="dashboard__card__body--first-value">
                      {{ cardDays.pending }}
                      <span class="total-card">
                        ({{ cardDays.pendingTotalCount }})
                      </span>
                    </span> <a class="dashboard__card__body--first-link" v-on:click="cardFilter(1)"> filtrar </a>
                  </div>
                  <div class="dashboard__card__body--second">
                  <span class="dashboard__card__body--first-card">
                    Em progresso
                  </span> <span class="dashboard__card__body--first-value">
                      {{ cardDays.progress }}
                      <span class="total-card">
                        ({{ cardDays.progressTotalCount }})
                      </span>
                    </span> <a class="dashboard__card__body--first-link" v-on:click="cardFilter(2)"> filtrar </a>
                  </div>
                  <div class="dashboard__card__body--third">
                    <span class="dashboard__card__body--first-card">
                      Concluído
                    </span> <span class="dashboard__card__body--first-value">
                      {{ cardDays.done }}
                      <span class="total-card">
                        ({{ cardDays.doneTotalCount }})
                      </span>
                    </span> <a class="dashboard__card__body--first-link" v-on:click="cardFilter(3)"> filtrar </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card Benefits -->
            <div class="col-md-6 card">
              <div class="col-md-12 card__content">
                <div class="card__content__header">
                <span class="card__content__header--title">
                  Pedidos de Benefícios
                  <a class="nav-link card__content__header--href" href="/beneficios-pedidos"
                     target="_blank"> Ver todos </a>
                </span>
                </div>
                <div class="card__content__body">
                  <table class="card__content__body--table">
                    <thead>
                    <tr>
                      <th>Empresa</th>
                      <th>Status</th>
                      <th>Valor</th>
                      <th>Atualizado em</th>
                      <th>Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(value, index) in contentDashboard.orders">
                      <td class="card__content__body--company--name">
                        <a :href="'/detalhes-da-empresa/' + value.companyId + '/' + value.contextCode" class="nav-link"
                           target="_blank">{{ value.name }}</a>
                      </td>
                      <td class="card__content__body--status">
                        <span v-if="value.status === 0" class="none">
                          Nenhum
                        </span> <span v-if="value.status === 1" class="draw">
                          Rascunho
                        </span> <span v-if="value.status === 2" class="waiting">
                          Aguardando
                        </span> <span v-if="value.status === 3" class="paid">
                          Pago
                        </span> <span v-if="value.status === 4" class="canceled">
                          Cancelado
                        </span>
                      </td>
                      <td class="card__content__body--value">
                        {{ value.value }}
                      </td>
                      <td class="card__content__body--updated">
                        {{ value.updatedAt | formatDate }} <span> às {{ value.updatedAt | formatHors24 }} </span>
                      </td>
                      <td class="card__content__body--actions">
                        <button>
                          <ion-icon name="chevron-forward"></ion-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- Card KYC -->
            <div class="col-md-6 card">
              <div class="col-md-12 card__content">
                <div class="card__content__header">
                <span class="card__content__header--title">
                  KYC
                  <a class="nav-link card__content__header--href" href="/beneficios-kyc" target="_blank"> Ver todos </a>
                </span>
                </div>
                <div class="card__content__body">
                  <table class="card__content__body--table">
                    <thead>
                    <tr>
                      <th>Funcionário</th>
                      <th>Status</th>
                      <th>Atualizado em</th>
                      <th>Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(value, index) in contentDashboard.kycs">
                      <td class="card__content__body--employee--name">
                        <a :href="'/usuario/' + value.id + '/' + value.contextCode" class="nav-link"
                           target="_blank">{{ value.name }}</a> {{ value.companyName }}
                      </td>
                      <td class="card__content__body--status--kyc">
                        <div v-if="value.status === 0" class="content--status content--status--unknow">
                          <span class="point">
                            Desconhecido
                          </span>
                        </div>
                        <div v-if="value.status === 1" class="content--status content--status--approved">
                          <span class="point">
                            Aprovado
                          </span>
                        </div>
                        <div v-if="value.status === 2" class="content--status content--status--waiting">
                          <span class="point">
                            Análise
                          </span>
                        </div>
                        <div v-if="value.status === 3" class="content--status content--status--manual-waiting">
                          <span class="point">
                            Análise Manual
                          </span>
                        </div>
                        <div v-if="value.status === 4" class="content--status content--status--disapproved">
                          <span class="point">
                            Reprovado
                          </span>
                        </div>
                      </td>
                      <td class="card__content__body--updated">
                        {{ value.updatedAt | formatDate }} <span> às {{ value.updatedAt | formatHors24 }} </span>
                      </td>
                      <td class="card__content__body--actions">
                        <button>
                          <ion-icon name="chevron-forward"></ion-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- Card Request Cards -->
            <div class="col-md-6 card">
              <div class="col-md-12 card__content">
                <div class="card__content__header">
                <span class="card__content__header--title">
                  Solicitações de Cartões
                  <a class="nav-link card__content__header--href" href="/solicitacao-cartao"
                     target="_blank"> Ver todos </a>
                </span>
                </div>
                <div class="card__content__body">
                  <table class="card__content__body--table">
                    <thead>
                    <tr>
                      <th>Empresa</th>
                      <th>Status</th>
                      <th>Qtde. Cartões</th>
                      <th>Atualizado em</th>
                      <th>Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(value, index) in contentDashboard.cards">
                      <td class="card__content__body--company--name">
                        <a :href="'/detalhes-da-empresa/' + value.companyId + '/' + value.contextCode" class="nav-link"
                           target="_blank">{{ value.name }}</a>
                      </td>
                      <td class="card__content__body--status">
                        <span v-if="value.status === 0" class="none">
                          Nenhum
                        </span> <span v-if="value.status === 1" class="pending">
                          Pendente
                        </span> <span v-if="value.status === 2" class="in-progress">
                          Em progresso
                        </span> <span v-if="value.status === 3" class="concluded">
                          Concluído
                        </span> <span v-if="value.status === 4" class="canceled">
                          Cancelado
                        </span>
                      </td>
                      <td class="card__content__body--value">
                        {{ value.total }}
                      </td>
                      <td class="card__content__body--updated">
                        {{ value.updatedAt | formatDate }} <span> às {{ value.updatedAt | formatHors24 }} </span>
                      </td>
                      <td class="card__content__body--actions">
                        <button>
                          <ion-icon name="chevron-forward"></ion-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- Card Last Companies -->
            <div class="col-md-6 card">
              <div class="col-md-12 card__content">
                <div class="card__content__header">
                <span class="card__content__header--title">
                  Últimas empresas
                  <a class="nav-link card__content__header--href" href="/ultimas-empresas"
                     target="_blank"> Ver todos </a>
                </span>
                </div>
                <div class="card__content__body">
                  <table class="card__content__body--table">
                    <thead>
                    <tr>
                      <th>Empresa</th>
                      <th>Qtde. Funcs.</th>
                      <th>Criada em</th>
                      <th>Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(value, index) in contentDashboard.companies">
                      <td class="card__content__body--company--name--latest">
                        <a :href="'/detalhes-da-empresa/' + value.id + '/' + value.contextCode" class="nav-link"
                           target="_blank">{{ value.name }}</a>
                      </td>
                      <td class="card__content__body--value">
                        {{ value.total }}
                      </td>
                      <td class="card__content__body--updated">
                        {{ value.createdAt | formatDate }} <span> às {{ value.createdAt | formatHors24 }} </span>
                      </td>
                      <td class="card__content__body--actions">
                        <button>
                          <ion-icon name="chevron-forward"></ion-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import {
  DASH_BENEFITS,
  CARDS_BENEFITS,
  ORDERS_BENEFITS,
  KYCS_BENEFITS,
  ORDERS_DAYS,
  KYCS_DAYS, CARDS_DAYS
} from "../../../../urlConfig";

import swal from "sweetalert";
import moment from "moment";
import {ALERT_SERVICE} from "../../../../msgAlertService";

export default {
  name: "benefits-dashboard",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
  },
  data() {
    return {
      loadingBenefits: false,
      contentDashboard: {},
      orderDays: {},
      kycDays: {},
      cardDays: {},
    };
  },
  methods: {
    getContentDashboardBenefits() {
      this.loadingBenefits = true;

      REQUEST_SERVICE.get(DASH_BENEFITS)
        .then((response) => {
          UTIL_SERVICE.console("RESULT DASHBOARD BENEFITS:", response.data);

          this.contentDashboard = response.data;

          this.orderDays = response.data.componentOrder
          this.kycDays = response.data.componentKyc
          this.cardDays = response.data.componentCardOrder

          this.loadingBenefits = false;
        })
        .catch((reason) => {
          this.loadingBenefits = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    getRequests(days) {

      const urlDays = ORDERS_DAYS + `?days=${days}`

      UTIL_SERVICE.console("URL SEARCH:", urlDays);
      REQUEST_SERVICE.get(urlDays).then((response) => {
        UTIL_SERVICE.console("RESULT:", response.data);

        this.orderDays = response.data.componentOrder

        this.loadingList = false;

      }).catch((reason) => {
        this.loadingList = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });

      if (days === 30) {
        $('#request30').addClass('activeRequest')
        $('#request60').removeClass('activeRequest')
      } else {
        $('#request30').removeClass('activeRequest')
        $('#request60').addClass('activeRequest')
      }
    },
    getKyc(days) {

      const urlDays = KYCS_DAYS + `?days=${days}`

      UTIL_SERVICE.console("URL SEARCH:", urlDays);
      REQUEST_SERVICE.get(urlDays).then((response) => {
        UTIL_SERVICE.console("RESULT:", response.data);

        this.kycDays = response.data.componentKyc

        this.loadingList = false;

      }).catch((reason) => {
        this.loadingList = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });

      if (days === 30) {
        $('#kyc30').addClass('activeKyc')
        $('#kyc60').removeClass('activeKyc')
      } else {
        $('#kyc30').removeClass('activeKyc')
        $('#kyc60').addClass('activeKyc')
      }
    },
    getCard(days) {

      const urlDays = CARDS_DAYS + `?days=${days}`

      UTIL_SERVICE.console("URL SEARCH:", urlDays);
      REQUEST_SERVICE.get(urlDays).then((response) => {
        UTIL_SERVICE.console("RESULT:", response.data);

        this.cardDays = response.data.componentCardOrder

        this.loadingList = false;

      }).catch((reason) => {
        this.loadingList = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });

      if (days === 30) {
        $('#card30').addClass('activeCard')
        $('#card60').removeClass('activeCard')
      } else {
        $('#card30').removeClass('activeCard')
        $('#card60').addClass('activeCard')
      }
    },
    requestFilter(status) {
      window.open(window.location.origin + "/beneficios-pedidos/" + status, '_blank');
    },
    kycFilter(status) {
      window.open(window.location.origin + "/beneficios-kyc/" + status, '_blank');
    },
    cardFilter(status) {
      window.open(window.location.origin + "/solicitacao-cartao/" + status, '_blank');
    },
  },
  beforeMount() {
    this.getContentDashboardBenefits();
  },
};
</script>

<style lang="scss" scoped>
.container-fluid {
  .first__row {
    .header {
      .header__content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        border-bottom: 1px solid var(--border-gray);
        margin-bottom: 20px;
        padding-bottom: 10px;
        margin-top: 6px;

        .header__content--balance {
          font-size: 18px;
          font-weight: 700;
          color: var(--classic-black);

          span {
            font-size: 18px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }

        .header__content--cards {
          display: flex;
          align-items: center;

          .header__content--cards--total {
            font-size: 18px;
            font-weight: 700;
            color: var(--classic-black);

            span {
              font-size: 18px;
              font-weight: 400;
              color: var(--dark-gray);
            }
          }

          .header__content--cards--status {
            border-left: 1px solid var(--border-gray);
            padding-left: 10px;
            margin-left: 10px;

            .header__content--cards--status--active {
              display: flex;
              align-items: center;

              font-weight: 700;
              font-size: 12px;
              line-height: 16.88px;
              color: var(--dark-gray);

              .circle-green {
                width: 9px;
                height: 9px;
                border-radius: 50% !important;
                background-color: #2acc6b;
                margin-right: 8px;
              }

              span {
                margin-left: 4px;
                font-weight: 400;
                color: var(--dark-gray);
              }
            }

            .header__content--cards--status--canceled {
              display: flex;
              align-items: center;

              font-weight: 700;
              font-size: 12px;
              line-height: 16.88px;
              color: var(--dark-gray);

              .circle-red {
                width: 9px;
                height: 9px;
                border-radius: 50% !important;
                background-color: #ff445d;
                margin-right: 8px;
              }

              span {
                margin-left: 4px;
                font-weight: 400;
                color: var(--dark-gray);
              }
            }
          }
        }
      }
    }

    .dashboard__card {
      margin-bottom: 30px;

      .dashboard__card__content {
        background: var(--classic-white);
        border-radius: 10px !important;
        height: 171px;
        padding: 20px;

        .dashboard__card__header {
          border-bottom: 1px solid var(--classic-gray);
          padding-bottom: 15px;

          .dashboard__card__header--title {
            font-size: 18px;
            color: var(--classic-black);
            font-weight: 700;
          }

          .dashboard__card__header--30 {
            text-decoration: none;
            float: right;
            font-size: 13px;
            font-weight: 400;
            padding: 5px 16px;
            color: var(--dark-gray);
            border-radius: 30px !important;
            margin-right: 10px;

            &:hover {
              color: var(--high-blue);
            }
          }

          .dashboard__card__header--60 {
            text-decoration: none;
            float: right;
            font-size: 13px;
            font-weight: 400;
            color: var(--dark-gray);
            padding: 5px 16px;
            border-radius: 30px !important;

            &:hover {
              color: var(--high-blue);
            }
          }

          .activeCard {
            color: var(--classic-white) !important;
            background: var(--high-blue);
            transition: .3s;

            &:hover {
              color: var(--classic-white) !important;
            }
          }

          .activeKyc {
            color: var(--classic-white) !important;
            background: var(--high-blue);
            transition: .3s;
          }

          .activeRequest {
            color: var(--classic-white) !important;
            background: var(--high-blue);
            transition: .3s;
          }
        }

        .dashboard__card__body {
          display: flex;
          justify-content: space-between;
          margin-top: 15px;

          .dashboard__card__body--first {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 33%;

            .dashboard__card__body--first-tag {
              border-radius: 4px !important;
              font-size: 12px;
              font-weight: 500;
              background: var(--light-yellow);
              color: var(--dark-gray);
              padding: 4px 16px;
              margin-bottom: 10px;
            }

            .dashboard__card__body--first-kyc {
              color: var(--dark-gray);
              font-size: 14px;
              font-weight: 400;

              display: flex;
              align-items: center;

              .point-yellow {
                border-radius: 4px !important;
                font-size: 12px;
                font-weight: 500;
                background: var(--light-yellow);
                color: var(--dark-gray);
                padding: 4px 28px;
                margin-bottom: 10px;
              }
            }

            .dashboard__card__body--first-card {
              border-radius: 4px !important;
              font-size: 12px;
              font-weight: 500;
              background: var(--light-yellow);
              color: var(--dark-gray);
              padding: 4px 23.5px;
              margin-bottom: 10px;
            }

            .dashboard__card__body--first-value {
              color: var(--dark-gray);
              font-size: 18px;
              font-weight: 700;

              .total-card {
                font-size: 12px;
                font-weight: 400;
                color: var(--border-gray);
              }
            }

            .dashboard__card__body--first-link {
              color: var(--high-blue);
              font-size: 13px;
              font-weight: 500;
            }
          }

          .dashboard__card__body--second {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 33%;

            .dashboard__card__body--first-tag {
              border-radius: 4px !important;
              font-size: 12px;
              font-weight: 500;
              background: var(--light-green);
              color: var(--classic-white);
              padding: 4px 36.5px;
              margin-bottom: 10px;
            }

            .dashboard__card__body--first-kyc {
              display: flex;
              align-items: center;

              color: var(--dark-gray);
              font-size: 14px;
              font-weight: 400;

              .point-green {
                border-radius: 4px !important;
                font-size: 12px;
                font-weight: 500;
                background: var(--light-green);
                color: var(--classic-white);
                padding: 4px 23px;
                margin-bottom: 10px;
              }
            }

            .dashboard__card__body--first-card {
              border-radius: 4px !important;
              font-size: 12px;
              font-weight: 500;
              background: var(--high-blue);
              color: var(--classic-white);
              padding: 4px 12.5px;
              margin-bottom: 10px;
            }

            .dashboard__card__body--first-value {
              color: var(--dark-gray);
              font-size: 18px;
              font-weight: 700;

              .total-card {
                font-size: 12px;
                font-weight: 400;
                color: var(--border-gray);
              }
            }

            .dashboard__card__body--first-link {
              color: var(--high-blue);
              font-size: 13px;
              font-weight: 500;
            }
          }

          .dashboard__card__body--third {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 33%;

            .dashboard__card__body--first-tag {
              border-radius: 4px !important;
              font-size: 12px;
              font-weight: 500;
              background: var(--light-red);
              color: var(--classic-white);
              padding: 4px 21.5px;
              margin-bottom: 10px;
            }

            .dashboard__card__body--first-kyc {
              color: var(--dark-gray);
              font-size: 14px;
              font-weight: 400;

              display: flex;
              align-items: center;

              .point-red {
                border-radius: 4px !important;
                font-size: 12px;
                font-weight: 500;
                background: var(--light-red);
                color: var(--classic-white);
                padding: 4px 19px;
                margin-bottom: 10px;
              }
            }

            .dashboard__card__body--first-card {
              border-radius: 4px !important;
              font-size: 12px;
              font-weight: 500;
              background: var(--light-green);
              color: var(--classic-white);
              padding: 4px 23px;
              margin-bottom: 10px;
            }

            .dashboard__card__body--first-value {
              color: var(--dark-gray);
              font-size: 18px;
              font-weight: 700;

              .total-card {
                font-size: 12px;
                font-weight: 400;
                color: var(--border-gray);
              }
            }

            .dashboard__card__body--first-link {
              color: var(--high-blue);
              font-size: 13px;
              font-weight: 500;
            }
          }
        }
      }
    }

    .card {
      margin-bottom: 30px;

      .card__content {
        background: var(--classic-white);
        border-radius: 10px !important;
        height: 411px;
        padding: 20px;
        position: relative;
        border: 2px solid transparent;

        &:hover {
          transition: .2s;
          border: 2px solid var(--high-blue);
        }

        .card__content__header {
          margin-bottom: 12px;

          .card__content__header--title {
            font-size: 16px;
            font-weight: 700;
            color: var(--dark-black);

            .card__content__header--href {
              font-size: 14px;
              font-weight: 500;
              color: var(--high-blue);
              margin-left: 10px;
            }
          }
        }

        .card__content__body {
          height: 91%;
          overflow-y: scroll;

          .card__content__body--table {
            width: 99%;
            max-width: 99%;
            margin-bottom: 20px;

            thead {
              font-size: 14px;
              color: var(--high-gray);
              line-height: 220%;
              padding-bottom: 5px;
              border-bottom: 1px solid var(--classic-gray);

              tr {
                th {
                  font-weight: 500 !important;
                }
              }
            }

            tbody {
              tr {
                border-bottom: 1px solid var(--classic-gray);

                .card__content__body--company--name {
                  width: 28%;
                  color: var(--dark-gray);
                  padding: 20px 0;

                  a {
                    display: list-item;
                    width: 140px;
                    white-space: nowrap;
                    overflow: hidden !important;
                    text-overflow: ellipsis;

                    font-size: 14px;
                    font-weight: 500;
                    color: var(--high-blue);
                    align-items: center;

                    ion-icon {
                      font-size: 14px;
                      margin-right: 4px;
                    }
                  }
                }

                .card__content__body--employee--name {
                  width: 40%;
                  color: var(--high-gray);
                  padding: 10.5px 0;
                  font-size: 13px;
                  font-weight: 400;

                  a {
                    display: list-item;
                    width: 220px;
                    white-space: nowrap;
                    overflow: hidden !important;
                    text-overflow: ellipsis;

                    font-size: 14px;
                    font-weight: 500;
                    color: var(--high-blue);
                    //display: flex;
                    align-items: center;

                    ion-icon {
                      font-size: 14px;
                      margin-right: 4px;
                    }
                  }
                }

                .card__content__body--company--name--latest {
                  width: 45%;
                  padding: 20px 0;

                  a {
                    display: list-item;
                    width: 240px;
                    white-space: nowrap;
                    overflow: hidden !important;
                    text-overflow: ellipsis;

                    font-size: 14px;
                    font-weight: 500;
                    color: var(--high-blue);
                    align-items: center;

                    ion-icon {
                      font-size: 14px;
                      margin-right: 4px;
                    }
                  }
                }

                .card__content__body--status {
                  span {
                    border-radius: 4px !important;
                    font-size: 12px;
                    font-weight: 500;
                    padding: 4px 16px;
                  }

                  .done {
                    color: var(--classic-white);
                    background: var(--dark-gray);
                    padding: 4px 16px;
                  }

                  .draw {
                    color: var(--classic-white);
                    background: var(--high-blue);
                    padding: 4px 24px;
                  }

                  .waiting {
                    color: var(--dark-gray);
                    background: var(--light-yellow);
                    padding: 4px 16px;
                  }

                  .paid {
                    background: var(--light-green);
                    color: var(--classic-white);
                    padding: 4px 38.5px;
                  }

                  .canceled {
                    background: var(--light-red);
                    color: var(--classic-white);
                    padding: 4px 22px;
                  }

                  .pending {
                    color: var(--dark-gray);
                    background: var(--light-yellow);
                    padding: 4px 25px;
                  }

                  .in-progress {
                    color: var(--classic-white);
                    background: var(--high-blue);
                    padding: 4px 12.5px;
                  }

                  .concluded {
                    background: var(--light-green);
                    color: var(--classic-white);
                    padding: 4px 25px;
                  }

                  .none {
                    background: var(--dark-gray);
                    color: var(--classic-white);
                    padding: 4px 27px;
                  }
                }

                .card__content__body--status--kyc {
                  .content--status {
                    display: flex;
                    align-items: center;

                    font-size: 14px;
                    font-weight: 400;
                    color: var(--dark-gray);

                    .point {
                      border-radius: 4px !important;
                      font-size: 12px;
                      font-weight: 500;
                      margin-bottom: 10px;
                    }
                  }

                  .content--status--waiting {
                    .point {
                      padding: 4px 32px;
                      color: var(--dark-gray);
                      background: var(--light-yellow);
                    }
                  }

                  .content--status--approved {
                    .point {
                      padding: 4px 25px;
                      color: var(--classic-white);
                      background: var(--light-green);
                    }
                  }

                  .content--status--disapproved {
                    .point {
                      padding: 4px 21.5px;
                      color: var(--classic-white);
                      background: var(--light-red);
                    }
                  }

                  .content--status--manual-waiting {
                    .point {
                      padding: 4px 8px;
                      color: var(--dark-gray);
                      background: var(--high-orange);
                    }
                  }

                  .content--status--unknow {
                    .point {
                      padding: 4px 10.5px;
                      color: var(--classic-white);
                      background: var(--dark-gray);
                    }
                  }
                }

                .card__content__body--value {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                .card__content__body--updated {
                  display: flex;
                  flex-direction: column;
                  margin-top: 11px;

                  font-size: 14px;
                  font-weight: 400;
                  color: var(--dark-gray);

                  span {
                    font-size: 12px;
                    font-weight: 400;
                    color: var(--high-gray);
                  }
                }

                .card__content__body--actions {
                  button {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    background: var(--background-gray);
                    width: 32px;
                    height: 32px;
                    padding: 0;
                    border: none;
                    border-radius: 4px !important;
                    transition: 0.2s;

                    ion-icon {
                      color: var(--dark-gray);
                      font-size: 22px;
                      transition: 0.2s;
                    }

                    &:hover {
                      background: var(--high-blue);

                      ion-icon {
                        color: var(--classic-white);
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .card__content__body::-webkit-scrollbar {
          width: 4px;
          position: absolute;
        }

        .card__content__body::-webkit-scrollbar-track {
          background-color: #e6e9ec;
          height: 4px;
          border-radius: 6px;
        }

        .card__content__body::-webkit-scrollbar-thumb {
          background: #3a424e;
          border-radius: 6px;
        }

        .card__content__body::-webkit-scrollbar-thumb:hover {
          background: lighten(#3a424e, 5%);
          transition: 0.5s;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/benefits/benefits-dashboard.vue